import React from 'react'
import { StyleSheet } from 'react-native'
import { Box, Text, ActivityIndicator } from '@/presentation/components'
import { useThemeClient } from '@/presentation/hooks'

type LoadingProps = {
  text?: string
}

export const Loading: React.FC<LoadingProps> = ({ text }) => {
  const { getAccentColor } = useThemeClient()

  return (
    <Box style={styles.container}>
      <ActivityIndicator size='large' color={getAccentColor()} />
      {!!text &&
        <Text style={{ fontWeight: '600', marginTop: 12 }}>{text}</Text>
      }
    </Box>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '50vh'
  }
})
